var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"breadcrumb-item",attrs:{"to":{ name : _vm.b.link },"active-class":"breadcrumb-item-active"}},[_c('span',[_vm._v(_vm._s(_vm.b.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }